export * from './post-kunden-art-request.interface';
export * from './post-kunden-art-response.interface';
export * from './post-kunden-art.shapes';
